import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, trackTrigger } from '../lib/analytics';

const WHATSAPP_CONTACT_RE = /wa\.me\/\d|api\.whatsapp\.com\/send/i;
const ERP_TICKET_RE = /erp\.artois\.ptitservices\.com/i;

/** Classify a clicked link into a conversion trigger name (or null). Exported for tests / reuse. */
export function triggerFromHref(href) {
  if (!href) return null;
  if (href.startsWith('tel:')) return 'phone';
  if (href.startsWith('mailto:')) return 'email';
  if (WHATSAPP_CONTACT_RE.test(href)) return 'whatsapp';
  if (ERP_TICKET_RE.test(href)) return 'contact';
  return null;
}

/**
 * Mounted once in App: records page views on every route change and
 * conversion clicks (call, WhatsApp, e-mail, ERP ticket) through event delegation.
 */
export default function AnalyticsTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith('/admin') || pathname.startsWith('/easer')) return undefined;
    // Small delay so react-helmet has applied the page <title>
    const t = setTimeout(() => trackPageView(pathname, document.title), 700);
    return () => clearTimeout(t);
  }, [pathname]);

  useEffect(() => {
    const onClick = (e) => {
      const target = e.target instanceof Element ? e.target : null;
      const link = target?.closest('a[href]');
      if (!link) return;
      const name = triggerFromHref(link.getAttribute('href') || '');
      if (name) trackTrigger(name, window.location.pathname);
    };
    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, []);

  return null;
}
